module.exports = function (e) {
  var t = {};

  function n(i) {
    if (t[i]) return t[i].exports;
    var r = t[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, i) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: i
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var i = Object.create(null);
    if (n.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) {
      n.d(i, r, function (t) {
        return e[t];
      }.bind(null, r));
    }
    return i;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "/dist/", n(n.s = 4);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  e.exports = n(6)();
}, function (e, t, n) {
  "use strict";

  var i, r;
  "undefined" != typeof window && window, void 0 === (r = "function" == typeof (i = function i() {
    if ("undefined" == typeof window) return null;

    var e = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")(),
        t = e.requestAnimationFrame || e.mozRequestAnimationFrame || e.webkitRequestAnimationFrame || function (t) {
      return e.setTimeout(t, 20);
    };

    function n(e, t) {
      var n = Object.prototype.toString.call(e),
          i = "[object Array]" === n || "[object NodeList]" === n || "[object HTMLCollection]" === n || "[object Object]" === n || "undefined" != typeof jQuery && e instanceof jQuery || "undefined" != typeof Elements && e instanceof Elements,
          r = 0,
          o = e.length;
      if (i) for (; r < o; r++) {
        t(e[r]);
      } else t(e);
    }

    function i(e) {
      if (!e.getBoundingClientRect) return {
        width: e.offsetWidth,
        height: e.offsetHeight
      };
      var t = e.getBoundingClientRect();
      return {
        width: Math.round(t.width),
        height: Math.round(t.height)
      };
    }

    function r(e, t) {
      Object.keys(t).forEach(function (n) {
        e.style[n] = t[n];
      });
    }

    var o = function o(e, a) {
      function s() {
        var e,
            t,
            n = [];
        this.add = function (e) {
          n.push(e);
        }, this.call = function (i) {
          for (e = 0, t = n.length; e < t; e++) {
            n[e].call(this, i);
          }
        }, this.remove = function (i) {
          var r = [];

          for (e = 0, t = n.length; e < t; e++) {
            n[e] !== i && r.push(n[e]);
          }

          n = r;
        }, this.length = function () {
          return n.length;
        };
      }

      function l(e, n) {
        if (e) if (e.resizedAttached) e.resizedAttached.add(n);else {
          e.resizedAttached = new s(), e.resizedAttached.add(n), e.resizeSensor = document.createElement("div"), e.resizeSensor.dir = "ltr", e.resizeSensor.className = "resize-sensor";
          var o = {
            pointerEvents: "none",
            position: "absolute",
            left: "0px",
            top: "0px",
            right: "0px",
            bottom: "0px",
            overflow: "hidden",
            zIndex: "-1",
            visibility: "hidden",
            maxWidth: "100%"
          },
              a = {
            position: "absolute",
            left: "0px",
            top: "0px",
            transition: "0s"
          };
          r(e.resizeSensor, o);
          var l = document.createElement("div");
          l.className = "resize-sensor-expand", r(l, o);
          var c = document.createElement("div");
          r(c, a), l.appendChild(c);
          var u = document.createElement("div");
          u.className = "resize-sensor-shrink", r(u, o);
          var d = document.createElement("div");
          r(d, a), r(d, {
            width: "200%",
            height: "200%"
          }), u.appendChild(d), e.resizeSensor.appendChild(l), e.resizeSensor.appendChild(u), e.appendChild(e.resizeSensor);
          var f,
              h,
              m = window.getComputedStyle(e),
              p = m ? m.getPropertyValue("position") : null;
          "absolute" !== p && "relative" !== p && "fixed" !== p && (e.style.position = "relative");

          var g = i(e),
              v = 0,
              y = 0,
              b = !0,
              w = 0,
              x = function x() {
            if (b) {
              if (0 === e.offsetWidth && 0 === e.offsetHeight) return void (w || (w = t(function () {
                w = 0, x();
              })));
              b = !1;
            }

            var n, i;
            n = e.offsetWidth, i = e.offsetHeight, c.style.width = n + 10 + "px", c.style.height = i + 10 + "px", l.scrollLeft = n + 10, l.scrollTop = i + 10, u.scrollLeft = n + 10, u.scrollTop = i + 10;
          };

          e.resizeSensor.resetSensor = x;

          var S = function S() {
            h = 0, f && (v = g.width, y = g.height, e.resizedAttached && e.resizedAttached.call(g));
          },
              E = function E() {
            g = i(e), (f = g.width !== v || g.height !== y) && !h && (h = t(S)), x();
          },
              O = function O(e, t, n) {
            e.attachEvent ? e.attachEvent("on" + t, n) : e.addEventListener(t, n);
          };

          O(l, "scroll", E), O(u, "scroll", E), t(x);
        }
      }

      n(e, function (e) {
        l(e, a);
      }), this.detach = function (t) {
        o.detach(e, t);
      }, this.reset = function () {
        e.resizeSensor.resetSensor();
      };
    };

    if (o.reset = function (e) {
      n(e, function (e) {
        e.resizeSensor.resetSensor();
      });
    }, o.detach = function (e, t) {
      n(e, function (e) {
        e && (e.resizedAttached && "function" == typeof t && (e.resizedAttached.remove(t), e.resizedAttached.length()) || e.resizeSensor && (e.contains(e.resizeSensor) && e.removeChild(e.resizeSensor), delete e.resizeSensor, delete e.resizedAttached));
      });
    }, "undefined" != typeof MutationObserver) {
      var a = new MutationObserver(function (e) {
        for (var t in e) {
          if (e.hasOwnProperty(t)) for (var n = e[t].addedNodes, i = 0; i < n.length; i++) {
            n[i].resizeSensor && o.reset(n[i]);
          }
        }
      });
      document.addEventListener("DOMContentLoaded", function (e) {
        a.observe(document.body, {
          childList: !0,
          subtree: !0
        });
      });
    }

    return o;
  }) ? i.call(t, n, t, e) : i) || (e.exports = r);
}, function (e, t, n) {
  e.exports = {
    ResizeSensor: n(2),
    ElementQueries: n(5)
  };
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var i = n(3),
      r = n(1),
      o = n.n(r),
      a = n(0),
      s = n.n(a);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);
      t && (i = i.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, i);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(n, !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(n).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function d(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if (!(Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e))) return;
      var n = [],
          i = !0,
          r = !1,
          o = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(i = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); i = !0) {
          ;
        }
      } catch (e) {
        r = !0, o = e;
      } finally {
        try {
          i || null == s.return || s.return();
        } finally {
          if (r) throw o;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  var f = {
    aspectRatio: o.a.oneOf(["taller", "wider"]),
    handle: o.a.node,
    handleSize: o.a.number,
    hover: o.a.bool,
    leftImage: o.a.string.isRequired,
    leftImageAlt: o.a.string,
    leftImageCss: o.a.object,
    leftImageLabel: o.a.string,
    onSliderPositionChange: o.a.func,
    rightImage: o.a.string.isRequired,
    rightImageAlt: o.a.string,
    rightImageCss: o.a.object,
    rightImageLabel: o.a.string,
    skeleton: o.a.element,
    sliderLineColor: o.a.string,
    sliderLineWidth: o.a.number,
    sliderPositionPercentage: o.a.number,
    vertical: o.a.bool
  };

  function h(e) {
    var t = e.aspectRatio,
        n = e.handle,
        r = e.handleSize,
        o = e.hover,
        l = e.leftImage,
        u = e.leftImageAlt,
        f = e.leftImageCss,
        h = e.leftImageLabel,
        m = e.onSliderPositionChange,
        p = e.rightImage,
        g = e.rightImageAlt,
        v = e.rightImageCss,
        y = e.rightImageLabel,
        b = e.skeleton,
        w = e.sliderLineColor,
        x = e.sliderLineWidth,
        S = e.sliderPositionPercentage,
        E = e.vertical,
        O = !E,
        L = d(Object(a.useState)(S), 2),
        j = L[0],
        I = L[1],
        z = d(Object(a.useState)(0), 2),
        C = z[0],
        A = z[1],
        P = d(Object(a.useState)(0), 2),
        R = P[0],
        M = P[1],
        T = d(Object(a.useState)(!1), 2),
        k = T[0],
        Q = T[1],
        W = d(Object(a.useState)(!1), 2),
        H = W[0],
        _ = W[1],
        q = d(Object(a.useState)(!1), 2),
        N = q[0],
        D = q[1],
        F = Object(a.useRef)(),
        B = Object(a.useRef)(),
        $ = Object(a.useRef)();
    Object(a.useEffect)(function () {
      var e = function e() {
        var e = F.current.getBoundingClientRect().width;
        A(e);
      };

      e();
      var t = F.current,
          n = new i.ResizeSensor(t, function () {
        e();
      });
      return function () {
        n.detach(t);
      };
    }, []), Object(a.useEffect)(function () {
      return $.current.complete && Q(!0), function () {
        Q(!1);
      };
    }, [l]), Object(a.useEffect)(function () {
      return B.current.complete && _(!0), function () {
        _(!1);
      };
    }, [p]);
    var V = H && k;
    Object(a.useEffect)(function () {
      var e = function e(_e) {
        var t = _e || window.event,
            n = t.touches ? t.touches[0].pageX : t.pageX,
            i = t.touches ? t.touches[0].pageY : t.pageY,
            r = n - window.pageXOffset,
            o = i - window.pageYOffset,
            a = B.current.getBoundingClientRect(),
            s = O ? r - a.left : o - a.top,
            l = 0 + x / 2,
            c = O ? C - x / 2 : R - x / 2;
        s < l && (s = l), s > c && (s = c), I(O ? s / C : s / R), m && m(O ? s / C : s / R);
      },
          n = function n(t) {
        D(!0), "touches" in t || t.preventDefault(), e(t), window.addEventListener("mousemove", e), window.addEventListener("touchmove", e);
      },
          i = function i() {
        D(!1), window.removeEventListener("mousemove", e), window.removeEventListener("touchmove", e);
      },
          r = F.current;

      if (V) {
        r.addEventListener("touchstart", n), window.addEventListener("touchend", i), o ? (r.addEventListener("mousemove", e), r.addEventListener("mouseleave", i)) : (r.addEventListener("mousedown", n), window.addEventListener("mouseup", i));
        var a = $.current.naturalHeight / $.current.naturalWidth,
            s = B.current.naturalHeight / B.current.naturalWidth,
            l = "taller" === t ? Math.max(a, s) : Math.min(a, s);
        M(C * l);
      }

      return function () {
        r.removeEventListener("touchstart", n), window.removeEventListener("touchend", i), r.removeEventListener("mousemove", e), r.removeEventListener("mouseleave", i), r.removeEventListener("mousedown", n), window.removeEventListener("mouseup", i), window.removeEventListener("mousemove", e), window.removeEventListener("touchmove", e);
      };
    }, [V, t, R, C, O, o, x, E]);
    var Y = {
      container: {
        boxSizing: "border-box",
        position: "relative",
        width: "100%",
        height: "".concat(R, "px"),
        overflow: "hidden"
      },
      rightImage: c({
        clip: O ? "rect(auto, auto, auto, ".concat(C * j, "px)") : "rect(".concat(R * j, "px, auto, auto, auto)"),
        display: "block",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        width: "100%"
      }, v),
      leftImage: c({
        clip: O ? "rect(auto, ".concat(C * j, "px, auto, auto)") : "rect(auto, auto, ".concat(R * j, "px, auto)"),
        display: "block",
        height: "100%",
        objectFit: "cover",
        position: "absolute",
        width: "100%"
      }, f),
      slider: {
        alignItems: "center",
        cursor: !o && O ? "ew-resize" : !o && !O && "ns-resize",
        display: "flex",
        flexDirection: O ? "column" : "row",
        height: O ? "100%" : "".concat(r, "px"),
        justifyContent: "center",
        left: O ? "".concat(C * j - r / 2, "px") : 0,
        position: "absolute",
        top: O ? 0 : "".concat(R * j - r / 2, "px"),
        width: O ? "".concat(r, "px") : "100%"
      },
      line: {
        background: w,
        boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        flex: "0 1 auto",
        height: O ? "100%" : "".concat(x, "px"),
        width: O ? "".concat(x, "px") : "100%"
      },
      handleCustom: {
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 0 auto",
        height: "auto",
        justifyContent: "center",
        width: "auto"
      },
      handleDefault: {
        alignItems: "center",
        border: "".concat(x, "px solid ").concat(w),
        borderRadius: "100%",
        boxShadow: "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
        boxSizing: "border-box",
        display: "flex",
        flex: "1 0 auto",
        height: "".concat(r, "px"),
        justifyContent: "center",
        width: "".concat(r, "px"),
        transform: O ? "none" : "rotate(90deg)"
      },
      leftArrow: {
        border: "inset ".concat(.15 * r, "px rgba(0,0,0,0)"),
        borderRight: "".concat(.15 * r, "px solid ").concat(w),
        height: "0px",
        marginLeft: "-".concat(.25 * r, "px"),
        marginRight: "".concat(.25 * r, "px"),
        width: "0px"
      },
      rightArrow: {
        border: "inset ".concat(.15 * r, "px rgba(0,0,0,0)"),
        borderLeft: "".concat(.15 * r, "px solid ").concat(w),
        height: "0px",
        marginRight: "-".concat(.25 * r, "px"),
        width: "0px"
      },
      leftLabel: {
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        left: O ? "5%" : "50%",
        opacity: N ? 0 : 1,
        padding: "10px 20px",
        position: "absolute",
        top: O ? "50%" : "3%",
        transform: O ? "translate(0,-50%)" : "translate(-50%, 0)",
        transition: "opacity 0.1s ease-out"
      },
      rightLabel: {
        background: "rgba(0, 0, 0, 0.5)",
        color: "white",
        opacity: N ? 0 : 1,
        padding: "10px 20px",
        position: "absolute",
        left: O ? null : "50%",
        right: O ? "5%" : null,
        top: O ? "50%" : null,
        bottom: O ? null : "3%",
        transform: O ? "translate(0,-50%)" : "translate(-50%, 0)",
        transition: "opacity 0.1s ease-out"
      },
      leftLabelContainer: {
        clip: O ? "rect(auto, ".concat(C * j, "px, auto, auto)") : "rect(auto, auto, ".concat(R * j, "px, auto)"),
        height: "100%",
        position: "absolute",
        width: "100%"
      },
      rightLabelContainer: {
        clip: O ? "rect(auto, auto, auto, ".concat(C * j, "px)") : "rect(".concat(R * j, "px, auto, auto, auto)"),
        height: "100%",
        position: "absolute",
        width: "100%"
      }
    };
    return s.a.createElement(s.a.Fragment, null, b && !V && s.a.createElement("div", {
      style: c({}, Y.container)
    }, b), s.a.createElement("div", {
      style: c({}, Y.container, {
        display: V ? "block" : "none"
      }),
      ref: F,
      "data-testid": "container"
    }, s.a.createElement("img", {
      onLoad: function onLoad() {
        return _(!0);
      },
      alt: g,
      "data-testid": "right-image",
      ref: B,
      src: p,
      style: Y.rightImage
    }), s.a.createElement("img", {
      onLoad: function onLoad() {
        return Q(!0);
      },
      alt: u,
      "data-testid": "left-image",
      ref: $,
      src: l,
      style: Y.leftImage
    }), s.a.createElement("div", {
      style: Y.slider
    }, s.a.createElement("div", {
      style: Y.line
    }), n ? s.a.createElement("div", {
      style: Y.handleCustom
    }, n) : s.a.createElement("div", {
      style: Y.handleDefault
    }, s.a.createElement("div", {
      style: Y.leftArrow
    }), s.a.createElement("div", {
      style: Y.rightArrow
    })), s.a.createElement("div", {
      style: Y.line
    })), h && s.a.createElement("div", {
      style: Y.leftLabelContainer
    }, s.a.createElement("div", {
      style: Y.leftLabel
    }, h)), y && s.a.createElement("div", {
      style: Y.rightLabelContainer
    }, s.a.createElement("div", {
      style: Y.rightLabel
    }, y))));
  }

  h.propTypes = f, h.defaultProps = {
    aspectRatio: "taller",
    handle: null,
    handleSize: 40,
    hover: !1,
    leftImageAlt: "",
    leftImageCss: {},
    leftImageLabel: null,
    onSliderPositionChange: function onSliderPositionChange() {},
    rightImageAlt: "",
    rightImageCss: {},
    rightImageLabel: null,
    skeleton: null,
    sliderLineColor: "#ffffff",
    sliderLineWidth: 2,
    sliderPositionPercentage: .5,
    vertical: !1
  }, t.default = h;
}, function (e, t, n) {
  "use strict";

  var i, r, o;
  "undefined" != typeof window && window, r = [n(2)], void 0 === (o = "function" == typeof (i = function i(e) {
    var t = function t() {
      var t,
          n = {},
          i = [];

      function r(e) {
        e || (e = document.documentElement);
        var t = window.getComputedStyle(e, null).fontSize;
        return parseFloat(t) || 16;
      }

      function o(e, t) {
        var n = t.split(/\d/),
            i = n[n.length - 1];

        switch (t = parseFloat(t), i) {
          case "px":
            return t;

          case "em":
            return t * r(e);

          case "rem":
            return t * r();

          case "vw":
            return t * document.documentElement.clientWidth / 100;

          case "vh":
            return t * document.documentElement.clientHeight / 100;

          case "vmin":
          case "vmax":
            var o = document.documentElement.clientWidth / 100,
                a = document.documentElement.clientHeight / 100;
            return t * (0, Math["vmin" === i ? "min" : "max"])(o, a);

          default:
            return t;
        }
      }

      function a(e, t) {
        var i, r, a, s, l, c, u, d;
        this.element = e;
        var f = ["min-width", "min-height", "max-width", "max-height"];

        this.call = function () {
          for (i in a = function (e) {
            if (!e.getBoundingClientRect) return {
              width: e.offsetWidth,
              height: e.offsetHeight
            };
            var t = e.getBoundingClientRect();
            return {
              width: Math.round(t.width),
              height: Math.round(t.height)
            };
          }(this.element), c = {}, n[t]) {
            n[t].hasOwnProperty(i) && (r = n[t][i], s = o(this.element, r.value), l = "width" === r.property ? a.width : a.height, d = r.mode + "-" + r.property, u = "", "min" === r.mode && l >= s && (u += r.value), "max" === r.mode && l <= s && (u += r.value), c[d] || (c[d] = ""), u && -1 === (" " + c[d] + " ").indexOf(" " + u + " ") && (c[d] += " " + u));
          }

          for (var e in f) {
            f.hasOwnProperty(e) && (c[f[e]] ? this.element.setAttribute(f[e], c[f[e]].substr(1)) : this.element.removeAttribute(f[e]));
          }
        };
      }

      function s(t, n) {
        t.elementQueriesSetupInformation || (t.elementQueriesSetupInformation = new a(t, n)), t.elementQueriesSensor || (t.elementQueriesSensor = new e(t, function () {
          t.elementQueriesSetupInformation.call();
        }));
      }

      function l(e, r, o, a) {
        if (void 0 === n[e]) {
          n[e] = [];
          var s = i.length;
          t.innerHTML += "\n" + e + " {animation: 0.1s element-queries;}", t.innerHTML += "\n" + e + " > .resize-sensor {min-width: " + s + "px;}", i.push(e);
        }

        n[e].push({
          mode: r,
          property: o,
          value: a
        });
      }

      function c(e) {
        var t;
        if (document.querySelectorAll && (t = e ? e.querySelectorAll.bind(e) : document.querySelectorAll.bind(document)), t || "undefined" == typeof $$ || (t = $$), t || "undefined" == typeof jQuery || (t = jQuery), !t) throw "No document.querySelectorAll, jQuery or Mootools's $$ found.";
        return t;
      }

      function u(t) {
        var n = [],
            i = [],
            r = [],
            o = 0,
            a = -1,
            s = [];

        for (var l in t.children) {
          if (t.children.hasOwnProperty(l) && t.children[l].tagName && "img" === t.children[l].tagName.toLowerCase()) {
            n.push(t.children[l]);
            var c = t.children[l].getAttribute("min-width") || t.children[l].getAttribute("data-min-width"),
                u = t.children[l].getAttribute("data-src") || t.children[l].getAttribute("url");
            r.push(u);
            var d = {
              minWidth: c
            };
            i.push(d), c ? t.children[l].style.display = "none" : (o = n.length - 1, t.children[l].style.display = "block");
          }
        }

        function f() {
          var e,
              l = !1;

          for (e in n) {
            n.hasOwnProperty(e) && i[e].minWidth && t.offsetWidth > i[e].minWidth && (l = e);
          }

          if (l || (l = o), a !== l) {
            if (s[l]) n[a].style.display = "none", n[l].style.display = "block", a = l;else {
              var c = new Image();
              c.onload = function () {
                n[l].src = r[l], n[a].style.display = "none", n[l].style.display = "block", s[l] = !0, a = l;
              }, c.src = r[l];
            }
          } else n[l].src = r[l];
        }

        a = o, t.resizeSensorInstance = new e(t, f), f();
      }

      var d = /,?[\s\t]*([^,\n]*?)((?:\[[\s\t]*?(?:min|max)-(?:width|height)[\s\t]*?[~$\^]?=[\s\t]*?"[^"]*?"[\s\t]*?])+)([^,\n\s\{]*)/gim,
          f = /\[[\s\t]*?(min|max)-(width|height)[\s\t]*?[~$\^]?=[\s\t]*?"([^"]*?)"[\s\t]*?]/gim;

      function h(e) {
        var t, n, i, r;

        for (e = e.replace(/'/g, '"'); null !== (t = d.exec(e));) {
          for (n = t[1] + t[3], i = t[2]; null !== (r = f.exec(i));) {
            l(n, r[1], r[2], r[3]);
          }
        }
      }

      function m(e) {
        var t = "";
        if (e) if ("string" == typeof e) -1 === (e = e.toLowerCase()).indexOf("min-width") && -1 === e.indexOf("max-width") || h(e);else for (var n = 0, i = e.length; n < i; n++) {
          1 === e[n].type ? -1 !== (t = e[n].selectorText || e[n].cssText).indexOf("min-height") || -1 !== t.indexOf("max-height") ? h(t) : -1 === t.indexOf("min-width") && -1 === t.indexOf("max-width") || h(t) : 4 === e[n].type ? m(e[n].cssRules || e[n].rules) : 3 === e[n].type && e[n].styleSheet.hasOwnProperty("cssRules") && m(e[n].styleSheet.cssRules);
        }
      }

      var p = !1;
      this.init = function () {
        var n = "animationstart";
        void 0 !== document.documentElement.style.webkitAnimationName ? n = "webkitAnimationStart" : void 0 !== document.documentElement.style.MozAnimationName ? n = "mozanimationstart" : void 0 !== document.documentElement.style.OAnimationName && (n = "oanimationstart"), document.body.addEventListener(n, function (t) {
          var n = t.target,
              r = n && window.getComputedStyle(n, null),
              o = r && r.getPropertyValue("animation-name");

          if (o && -1 !== o.indexOf("element-queries")) {
            n.elementQueriesSensor = new e(n, function () {
              n.elementQueriesSetupInformation && n.elementQueriesSetupInformation.call();
            });
            var a = window.getComputedStyle(n.resizeSensor, null).getPropertyValue("min-width");
            a = parseInt(a.replace("px", "")), s(t.target, i[a]);
          }
        }), p || ((t = document.createElement("style")).type = "text/css", t.innerHTML = "[responsive-image] > img, [data-responsive-image] {overflow: hidden; padding: 0; } [responsive-image] > img, [data-responsive-image] > img {width: 100%;}", t.innerHTML += "\n@keyframes element-queries { 0% { visibility: inherit; } }", document.getElementsByTagName("head")[0].appendChild(t), p = !0);

        for (var r = 0, o = document.styleSheets.length; r < o; r++) {
          try {
            document.styleSheets[r].href && 0 === document.styleSheets[r].href.indexOf("file://") && console.warn("CssElementQueries: unable to parse local css files, " + document.styleSheets[r].href), m(document.styleSheets[r].cssRules || document.styleSheets[r].rules || document.styleSheets[r].cssText);
          } catch (e) {}
        }

        !function () {
          for (var e = c()("[data-responsive-image],[responsive-image]"), t = 0, n = e.length; t < n; t++) {
            u(e[t]);
          }
        }();
      }, this.findElementQueriesElements = function (e) {
        !function (e) {
          var t = c(e);

          for (var i in n) {
            if (n.hasOwnProperty(i)) for (var r = t(i, e), o = 0, a = r.length; o < a; o++) {
              s(r[o], i);
            }
          }
        }(e);
      }, this.update = function () {
        this.init();
      };
    };

    return t.update = function () {
      t.instance.update();
    }, t.detach = function (e) {
      e.elementQueriesSetupInformation ? (e.elementQueriesSensor.detach(), delete e.elementQueriesSetupInformation, delete e.elementQueriesSensor) : e.resizeSensorInstance && (e.resizeSensorInstance.detach(), delete e.resizeSensorInstance);
    }, t.init = function () {
      t.instance || (t.instance = new t()), t.instance.init();
    }, t.findElementQueriesElements = function (e) {
      t.instance.findElementQueriesElements(e);
    }, t.listen = function () {
      !function (e) {
        if (document.addEventListener) document.addEventListener("DOMContentLoaded", e, !1);else if (/KHTML|WebKit|iCab/i.test(navigator.userAgent)) var t = setInterval(function () {
          /loaded|complete/i.test(document.readyState) && (e(), clearInterval(t));
        }, 10);else window.onload = e;
      }(t.init);
    }, t;
  }) ? i.apply(t, r) : i) || (e.exports = o);
}, function (e, t, n) {
  "use strict";

  var i = n(7);

  function r() {}

  function o() {}

  o.resetWarningCache = r, e.exports = function () {
    function e(e, t, n, r, o, a) {
      if (a !== i) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: o,
      resetWarningCache: r
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}]);